module.exports = __webpack_public_path__ + "img/male.5f224ae2.svg";